/**
 * Timezone utility functions for converting between local time and UTC
 */

/**
 * Converts local time string to UTC time string
 * @param {string} localTimeString - Time in HH:MM format (e.g., "10:00")
 * @returns {string} UTC time in HH:MM format
 */
export const convertLocalTimeToUTC = (localTimeString) => {
    if (!localTimeString || typeof localTimeString !== 'string') {
        return localTimeString;
    }

    const [hours, minutes] = localTimeString.split(':').map(Number);
    
    // Create a date object with today's date and the specified time
    const localDateTime = new Date();
    localDateTime.setHours(hours, minutes, 0, 0);
    
    // Get UTC hours and minutes
    const utcHours = String(localDateTime.getUTCHours()).padStart(2, '0');
    const utcMinutes = String(localDateTime.getUTCMinutes()).padStart(2, '0');
    
    return `${utcHours}:${utcMinutes}`;
};

/**
 * Converts UTC time string to local time string
 * @param {string} utcTimeString - Time in HH:MM format (e.g., "07:00")
 * @returns {string} Local time in HH:MM format
 */
export const convertUTCTimeToLocal = (utcTimeString) => {
    if (!utcTimeString || typeof utcTimeString !== 'string') {
        return utcTimeString;
    }

    const [hours, minutes] = utcTimeString.split(':').map(Number);
    
    // Create a date object with today's date and the UTC time
    const utcDateTime = new Date();
    utcDateTime.setUTCHours(hours, minutes, 0, 0);
    
    // Get local hours and minutes
    const localHours = String(utcDateTime.getHours()).padStart(2, '0');
    const localMinutes = String(utcDateTime.getMinutes()).padStart(2, '0');
    
    return `${localHours}:${localMinutes}`;
};

/**
 * Gets the user's timezone for display purposes
 * @returns {string} User's timezone (e.g., "Asia/Jerusalem")
 */
export const getUserTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

/**
 * Gets the user's timezone offset in minutes
 * @returns {number} Timezone offset in minutes (negative for timezones east of UTC)
 */
export const getUserTimezoneOffset = () => {
    return -new Date().getTimezoneOffset();
};